import { supabase } from '../lib/supabase';

/**
 * Next Departure Service - Handles next departure info operations
 */
export const nextDepartureService = {
  /**
   * Get active next departure info
   */
  async getActive() {
    try {
      const { data, error } = await supabase
        ?.from('next_departure_info')
        ?.select('*')
        ?.eq('is_active', true)
        ?.order('created_at', { ascending: false })
        ?.limit(1)
        ?.single();

      if (error) {
        // If no active record found, return null instead of throwing
        if (error?.code === 'PGRST116') {
          return null;
        }
        throw error;
      }

      // Transform snake_case to camelCase
      return {
        id: data?.id,
        departureDate: data?.departure_date,
        vesselName: data?.vessel_name,
        estimatedArrival: data?.estimated_arrival,
        port: data?.port,
        isActive: data?.is_active,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error fetching active next departure:', error);
      throw error;
    }
  },

  /**
   * Get all next departure records (admin only)
   */
  async getAll() {
    try {
      const { data, error } = await supabase
        ?.from('next_departure_info')
        ?.select('*')
        ?.order('created_at', { ascending: false });

      if (error) throw error;

      return (data || [])?.map(item => ({
        id: item?.id,
        departureDate: item?.departure_date,
        vesselName: item?.vessel_name,
        estimatedArrival: item?.estimated_arrival,
        port: item?.port,
        isActive: item?.is_active,
        createdAt: item?.created_at,
        updatedAt: item?.updated_at
      }));
    } catch (error) {
      console.error('Error fetching all next departures:', error);
      throw error;
    }
  },

  /**
   * Create or update next departure info
   */
  async upsert(formData) {
    try {
      // Deactivate all existing records first
      await supabase
        ?.from('next_departure_info')
        ?.update({ is_active: false })
        ?.eq('is_active', true);

      // Insert new active record
      const { data, error } = await supabase
        ?.from('next_departure_info')
        ?.insert({
          departure_date: formData?.departureDate,
          vessel_name: formData?.vesselName,
          estimated_arrival: formData?.estimatedArrival,
          port: formData?.port || 'Anvers → Abidjan',
          is_active: true
        })
        ?.select()
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        departureDate: data?.departure_date,
        vesselName: data?.vessel_name,
        estimatedArrival: data?.estimated_arrival,
        port: data?.port,
        isActive: data?.is_active,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error upserting next departure:', error);
      throw error;
    }
  },

  /**
   * Delete next departure record
   */
  async delete(id) {
    try {
      const { error } = await supabase
        ?.from('next_departure_info')
        ?.delete()
        ?.eq('id', id);

      if (error) throw error;
    } catch (error) {
      console.error('Error deleting next departure:', error);
      throw error;
    }
  }
};

export default nextDepartureService;